import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

// Redux
import { loadRelatedJobs } from 'redux/modules/jobs';

// Twine components
import JobCard from 'components/JobCard/JobCard';
import Loader from '../Loader/Loader';

import {
  toSeoUrl,
  toPlural,
  seoCountryNameToCountyCode,
} from 'helpers/HelperFunctions';

//Styles
import styles from './RelatedJobs.module.scss';

const RelatedJobs = ({
  briefId,
  role,
  skill,
  user,
  country,
  city,
  locationWithRoleLink,
}) => {
  const dispatch = useDispatch();
  const selectJobs = (state) => state.jobs;
  const jobsState = useSelector(selectJobs);

  const location = city ? city : country;
  const locationWithoutRoleLink = city
    ? `/jobs/in/${toSeoUrl(country)}/${toSeoUrl(city)}`
    : `/jobs/in/${toSeoUrl(country)}`;

  useEffect(() => {
    dispatch(loadRelatedJobs(briefId, role, user, skill));
  }, []);

  const relatedJobsList = jobsState?.relatedJobs.map((rj) => {
    return <JobCard key={rj.id} brief={rj} relatedJobs />;
  });

  let findUrl = '/hire-a-freelancer';
  if (role && country && city) {
    findUrl = `/find/${toSeoUrl(toPlural(role))}/${seoCountryNameToCountyCode(
      country
    )}/${toSeoUrl(city)}`;
  } else if (role && country) {
    findUrl = `/find/${toSeoUrl(toPlural(role))}/${seoCountryNameToCountyCode(
      country
    )}`;
  } else if (role) {
    findUrl = `/find/${toSeoUrl(toPlural(role))}`;
  }

  return (
    <div className={styles.RelatedJobs}>
      <>
        <h2 className={styles.RelatedJobs__title}>Similar Jobs</h2>
        {jobsState.loading && <Loader loading />}
        {relatedJobsList}
      </>
      <div className={styles.RelatedJobs__link}>
        -{' '}
        <a href={'/jobs/' + toPlural(toSeoUrl(role))}>Find more {role} jobs</a>
        {location ? (
          <>
            <br />-{' '}
            <a href={locationWithRoleLink}>
              Find more {role} jobs in {location}
            </a>
            <br />-{' '}
            <a href={locationWithoutRoleLink}>
              Browse other jobs in {location}
            </a>
          </>
        ) : (
          <>
            <br />- <a href="/jobs">Find more freelance jobs</a>
          </>
        )}
        <hr />-{' '}
        <a href={'/find/' + toPlural(toSeoUrl(role))}>Hire an expert {role}</a>
        {location ? (
          <>
            <br />-{' '}
            <a href={findUrl}>
              Hire a {role} in {location}
            </a>
          </>
        ) : (
          <>
            <br />- <a href={findUrl}>Hire expert {role} near you</a>
          </>
        )}
      </div>
    </div>
  );
};

RelatedJobs.propTypes = {
  briefId: PropTypes.number,
  role: PropTypes.string,
  skill: PropTypes.string,
  user: PropTypes.object,
  country: PropTypes.string,
  city: PropTypes.string,
  locationWithRoleLink: PropTypes.string,
};

export default RelatedJobs;
